<template>
    <div class="mt-4">
        <div class="collapse" :id="collapseId" :data-parent="parentCollapseId">
            <div class="row">
                <div class="col-sm-6 col-lg-2 filter-column">
                    <page-filter :view-type="'mobile'"
                                 :page-filter-type="'movie'"
                                 :id-prefix="idPrefix"
                                 :icon="'fas fa-layer-group'"
                                 :plural="'Genres'"
                                 :input-name="'genre'"
                                 :items="filterGenres"></page-filter>
                </div>
            </div>

            <div v-if="showBottomSpacer" class="pt-10"></div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            collapseId: {
                type: String,
                default: '',
            },
            parentCollapseId: {
                type: String,
                default: '',
            },
            showBottomSpacer: {
                type: Boolean,
                default: false,
            },
            idPrefix: {
                type: String,
                default: '',
            }
        },
        data() {
            return {
                filterGenres: MrMovie.defaults.filterGenres,
            };
        },
    };
</script>



// WEBPACK FOOTER //
// resources/js/components/movies/MoviesOverviewFiltersMobile.vue